var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "green",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "share1",
    className: "cls-1",
    d: "M1160,104a3.986,3.986,0,0,1-3.19-1.6l-8.84,5.292c0.01,0.105.03,0.2,0.03,0.312,0,0.128-.03.249-0.04,0.374l8.8,5.3A3.986,3.986,0,1,1,1156,116c0-.149.03-0.291,0.04-0.436l-8.82-5.216a4,4,0,1,1-.06-4.777l8.88-5.189c-0.01-.127-0.04-0.251-0.04-0.382A4,4,0,1,1,1160,104Zm0,14a2,2,0,1,0-2-2A2,2,0,0,0,1160,118Zm-16-12a2,2,0,1,0,2,2A2,2,0,0,0,1144,106Zm16-8a2,2,0,1,0,2,2A2,2,0,0,0,1160,98Z",
    transform: "translate(-1140 -96)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.bf2ef84c7865d728faad040c5bd06066.svg";
export { ForwardRef as ReactComponent };